import PubSub from "underpub-js";
import Slick from "slick-carousel";
import Equalizer from "../../../../scripts/classes/Equalizer";
import Aframe from 'aframe';

var GalleryWideSlider = function(options) {

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

GalleryWideSlider.prototype.init = function() {

	var self = this;

	// sliders
	this.$cardSlider = this.options.$el.find('.card-slider');

	// initialize card slider
	this.$cardSlider.slick({
		arrows: false,
		fade: false,
		speed: 750,
		slidesToShow: 1,
		infinite: false,
		centerMode: true,
		centerPadding: '28%',
		initialSlide: 1,
		responsive: [
		
			{
				breakpoint: 2600,
				settings: {
					centerPadding: '26%'
				}
			},
			{
				breakpoint: 2000,
				settings: {
					centerPadding: '24%'
				}
			},
			{
				breakpoint: 1700,
				settings: {
					centerPadding: '22%'
				}
			},
			{
				breakpoint: 1200,
				settings: {
					centerPadding: '20%',
				}
			},
			{
				breakpoint: 768,
				settings: {
					centerPadding: '120px',
				}
			},
			{
				breakpoint: 640,
				settings: {
					centerPadding: '90px',
				}
			},
			{
				breakpoint: 560,
				settings: {
					centerPadding: '70px',
				}
			},
			{
				breakpoint: 500,
				settings: {
					centerPadding: '12%',
				}
			},
			{
				breakpoint: 420,
				settings: {
					centerPadding: '8%',
				}
			}
		]

	});

	// equalize heights of cards
	this.slideEq = new Equalizer( self.options.$el.find('.slick-slide .card') );

	this.slideEq.equalizeHeights();

	$(window).on('load', function() {
		self.slideEq.equalizeHeights();
	});

	PubSub.subscribe("resized", function(){
		self.slideEq.equalizeHeights();
	});

	// initialize 360 image viewers
	this.options.$el.find('.image-360-viewer').each(function() {

		var image360Url = $(this).data('imageUrl');
		var scene = self.getScene(image360Url);

		$(this).append(scene);

	});

	this.options.$el.on('click', '.image-360-viewer-link', function() {
		console.log('360 image popup activate');
		var overlayId = $(this).data('overlayId');
		var $overlay = self.options.$el.find('#' + overlayId);
		$overlay.addClass('active');
	});

	this.options.$el.on('click', '.image-360-viewer-outer-wrapper .close-x', function() {
		$(this).closest('.image-360-viewer-outer-wrapper').removeClass('active');
	});

};

GalleryWideSlider.prototype.getScene = function(imageSrc){

	return `
		<a-scene embedded="true">
			<a-sky src="` + imageSrc + `" rotation="0 -130 0"></a-sky>
		</a-scene>
	`;

};

export default GalleryWideSlider;
